// Reine Entscheidungs-Logik für den Otto-Settings-Health-Check. IO-frei, unit-testbar.

export type HealthAction = 'ok' | 'reauth' | 'reset' | 'warehouse-invalid' | 'transient';

export interface HealthInput {
  storedChannelId: string;
  storedWarehouseId: string | null;
  /** null = Kanal-Liste konnte nicht geladen werden (kein autoritatives Urteil möglich). */
  channels: Array<{ id: string }> | null;
  /** null = Lager-Liste konnte nicht geladen werden. */
  warehouses: Array<{ id: string }> | null;
  /** true, wenn ein Vario-Call einen Auth-Fehler (401) lieferte. */
  authError: boolean;
  /** true, wenn ein Vario-Call non-auth fehlschlug (Netz/5xx). */
  transientError: boolean;
}

/**
 * Prioritätsreihenfolge (erste zutreffende Regel gewinnt):
 *  1. authError       → 'reauth'    (Token ungültig; Link bleibt)
 *  2. transientError  → 'transient' (kein autoritatives Urteil; nie Reset)
 *  3. Kanal-Liste OK, storedChannelId fehlt → 'reset' (autoritativ gelöscht)
 *  4. Lager-Liste OK, storedWarehouseId gesetzt & fehlt → 'warehouse-invalid'
 *  5. sonst → 'ok'
 */
export function interpretSettingsHealth(i: HealthInput): HealthAction {
  if (i.authError) return 'reauth';
  if (i.transientError) return 'transient';
  if (i.channels !== null && !i.channels.some((c) => c.id === i.storedChannelId)) return 'reset';
  if (i.warehouses !== null && i.storedWarehouseId && !i.warehouses.some((w) => w.id === i.storedWarehouseId)) {
    return 'warehouse-invalid';
  }
  return 'ok';
}
